import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
  * @function evaluate - evaluate docRipperRipTitleBehavior
  */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const importField = content.importField,
    importFormType = content.importFormType;
  const _Object$values = Object.values(importFormType),
    _Object$values2 = _slicedToArray(_Object$values, 1),
    formTypeTitle = _Object$values2[0].title;
  const _Object$values3 = Object.values(importField),
    _Object$values4 = _slicedToArray(_Object$values3, 1),
    fieldTitle = _Object$values4[0].title;
  const pages = (await evaluateSource({
    type: 'getCacheValueBehavior',
    name: 'docRipper/matches/pages'
  })) || [];
  return pages.length ? "Rip ".concat(pages.length, " pages with linked '").concat(fieldTitle, "' values and associate them with select '").concat(formTypeTitle, "' assets.") : 'No matches found. Refresh to try a different Field selection or PDF.';
};
export default {
  evaluate
};